import * as React from "react"

function LetterIcon(props) {
  const fillColor = props.color || '#fff'

  return (
    <svg
      width={20}
      height={19}
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.427 8.095l-17-8A1 1 0 00.03 1.242l1.212 4.85L9 9l-7.758 2.91L.03 16.757a.998.998 0 001.396 1.147l17-8a1 1 0 000-1.81z"
        fill={fillColor}
      />
    </svg>
  )
}

export default LetterIcon
